import React from "react";
import { useQuery, useSubscription } from "@apollo/client";
import {
  MY_HR_GET_ORG_UNITS_ADMIN_LIST,
  MY_HR_ORG_UNITS_SUBSCRIPTION,
} from "my-hr/graphql";
import { OcErrorBoundary, OcFilterItem } from "oc/components";
import { useOcFiltersData, useOcPolling, useOcQueryParams } from "oc/hooks";

type OcOrgUnitFilterProps = {
  roleFilters: {
    orgUnit?: any[]; // Replace 'any' with the actual type if known
    [key: string]: any;
  };
  onAddFilter: (item: any) => void; // Replace 'any' with the actual type if known
  onRemoveFilter: (item: any) => void; // Replace 'any' with the actual type if known
  contract?: any; // Replace 'any' with the actual type if known
  product?: any; // Replace 'any' with the actual type if known
  role?: any; // Replace 'any' with the actual type if known
};

export const OcOrgUnitFilter: React.FC<OcOrgUnitFilterProps> = ({
  roleFilters,
  onAddFilter,
  onRemoveFilter,
  contract,
  product,
  role,
}) => {
  const filterType = "orgUnit";

  const entity = { orgUnits: roleFilters?.orgUnit || [] };
  const stateId = "ocOrgUnitFilter";
  const { search, setSearch, setPageSize, queryParams } = useOcQueryParams({
    stateId,
    entity,
    contract,
    product,
    role,
    roleFilters,
  });

  const {
    data: rawData,
    loading,
    fetchMore,
  } = useQuery(MY_HR_GET_ORG_UNITS_ADMIN_LIST, {
    fetchPolicy: "no-cache",
    pollInterval: useOcPolling(1000 * 60),
    variables: queryParams,
  });

  useSubscription(MY_HR_ORG_UNITS_SUBSCRIPTION, {
    skip: !rawData,
    fetchPolicy: "network-only",
    variables: queryParams,
  });

  const data = rawData?.orgUnitsAdminList;

  const fetchMoreNoReturn = (...args: any[]) => {
    (fetchMore as any)(...args).catch(() => { });
  };

  const {
    availableItems,
    selectedItems,
    handleFetchMore,
    handleSearch,
    handleClearSearch,
  } = useOcFiltersData({
    data,
    fetchMore: fetchMoreNoReturn,
    setSearch: (value: string) => {
      setSearch(value);
    },
    setPageSize: (size: number) => {
      setPageSize(size);
    },
    product,
    role,
    filterType,
  });

  return (
    <OcErrorBoundary>
      <OcFilterItem
        filterType={filterType}
        selectedItems={selectedItems}
        availableItems={availableItems}
        search={search}
        onLoading={loading}
        onSearch={(value: string) => {
          handleSearch(value);
        }}
        onClearSearch={() => {
          handleClearSearch();
        }}
        onAddFilter={onAddFilter}
        onRemoveFilter={onRemoveFilter}
        onFetchMore={() => {
          handleFetchMore();
        }}
        showLists={true}
      />
    </OcErrorBoundary>
  );
};

export default OcOrgUnitFilter;
